import { Link } from "@inertiajs/react";
import { ShoppingBag } from "lucide-react";

export default function CartEmpty({ compact = false, onContinue }) {
  return (
    <div className="rounded-[2rem] border border-border bg-neutral-100/30 px-6 py-16 text-center">
      <div className="mx-auto flex size-16 items-center justify-center rounded-full bg-white shadow-lg">
        <ShoppingBag className="size-7" />
      </div>

      <h2 className="mt-6 text-2xl font-black uppercase">
        Your cart is empty
      </h2>

      {!compact && (
        <p className="mx-auto mt-3 max-w-md text-sm leading-7 text-muted-foreground">
          Add premium caps and accessories to start your order.
        </p>
      )}

      <Link
        href="/shop"
        onClick={onContinue}
        className="mt-8 inline-flex rounded-full bg-black px-6 py-3 text-sm font-bold text-white"
      >
        Continue Shopping
      </Link>
    </div>
  );
}